import './assets/style/App.scss'
import LeftSidebar from './module/left-sidebar'
import AuthRoute from './routes/main-router'

function App() {
  return (
    <div className="App">
      <LeftSidebar />
      <AuthRoute />
    </div>
  )
}

export default App
